export default {
  namespaced: true,
  pisos: {
    title: "Andares",
    unit_id: "Instalação",
    name: "Nome",
    floor_number: "Número do andar",
    headcount: "Capacidade máxima",
    headcount_table: "Ocupação",
    is_occupied: "Está ocupado?",
    active_inactive: "Ativo/Inativo",
    active: "Ativo",
    inactive: "Inativo",
    rems: "REMS",
    sirh: "SIRH",
    sector: "Setor",
  },
};